<template>
  <div>
    <h3 class="mb-4">Products</h3>
    <div class="product-wrapper">
      <div class="product-filter">
        <div class="product-filter--header"></div>
        <a-input-search
          :default-value="$route.query.q"
          :placeholder="$t('store.searchProduct')"
          @change="debouncedQueryChanged($event.target.value)"
          class="mb-3 mr-3"
        />
        <a-select
          :default-value="selectedSort"
          style="max-width: 250px; width: 100%"
          placeholder="Sort by"
          @change="onSortSelectChange"
        >
          <a-select-option
            v-for="item in sortItems"
            :key="item.value.join('__')"
            :value="item.value.join('__')"
          >
            {{ item.label }}
          </a-select-option>
        </a-select>
      </div>
      <div class="product-content">
        <div
          v-for="(product, index) in products"
          :key="index + product.product_id"
          class="product-list"
        >
          <CatalogueListItem :product="product" />
        </div>

        <div class="">
          <a-pagination
            :default-current="$route.query.page"
            :total="total"
            hideOnSinglePage
            class="mx-auto d-flex justify-content-center"
            @change="(page) => $router.push({ query: { ...$route.query, page } })"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiClient from '@/services/axios'
import { mapState } from 'vuex'
import debounce from 'lodash/debounce'
import CatalogueListItem from './CatalogueListItem.vue'

const sort = [
  {
    label: 'Product Name [A-Z]',
    value: ['product_name', 'asc'],
  },
  {
    label: 'Product Name [Z-A]',
    value: ['product_name', 'desc'],
  },
  // {
  //   label: 'Item sold',
  //   value: ['sold', 'desc'],
  // },
  // {
  //   label: 'Discount',
  //   value: ['discount', 'desc'],
  // },
  // {
  //   label: 'Price low to high',
  //   value: ['price', 'asc'],
  // },
  // {
  //   label: 'Price high to low',
  //   value: ['price', 'desc'],
  // },
  // {
  //   label: 'Featured Product',
  //   value: ['featured', 'asc'],
  // },
  // {
  //   label: 'Best Seller Product',
  //   value: ['bestseller', 'asc'],
  // },
  // {
  //   label: 'Newest Product',
  //   value: ['newproduct', 'asc'],
  // },
  // {
  //   label: 'Special Product',
  //   value: ['special', 'asc'],
  // },
]

export default {
  components: { CatalogueListItem },
  data() {
    return {
      fetching: true,
      products: [],
      perPage: 35,
      total: 0,
    }
  },
  computed: {
    ...mapState('user', {
      channelId: (state) => state.channel_id,
    }),
    /**
     * @returns {object[]}
     */
    sortItems() {
      return sort
    },
    /**
     * @returns {string}
     */
    selectedSort() {
      return this.$route.query.sort && this.$route.query.order
        ? [this.$route.query.sort, this.$route.query.order].join('__')
        : undefined
    },
  },
  watch: {
    '$route.query'() {
      this.fetchProducts()
    },
  },
  created() {
    this.debouncedQueryChanged = debounce((val) => {
      this.$router.push({
        path: '/purchase/catalogue',
        query: { ...this.$route.query, q: val || undefined },
      })
    }, 250)
  },
  mounted() {
    this.fetchProducts()
  },
  methods: {
    async fetchProducts() {
      this.fetching = true
      try {
        const { data: response } = await apiClient.get(
          `/products/private/channels/${this.channelId}`,
          {
            params: {
              ...this.$route.query,
              limit: this.perPage,
            },
          },
        )
        this.products = response.data
        this.total = response.total_row
      } catch (err) {
        //
      }

      this.fetching = false
    },
    onSortSelectChange(value) {
      const [sort, order] = value.split('__')
      this.$router.push({
        query: {
          ...this.$route.query,
          sort,
          order,
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.product {
  &-wrapper {
    max-width: 768px;
  }

  &-filter {
    width: 100%;
    margin-bottom: 1.5rem;
    display: flex;
    justify-content: space-between;

    // @media (min-width: 992px) {
    //   width: 200px;
    //   margin-right: 1rem;
    // }
  }

  &-content {
    width: 100%;
    flex-grow: 1;

    @media (min-width: 992px) {
      width: auto;
    }
  }
}
</style>
